import { render, staticRenderFns } from "./AgentSideMenu.vue?vue&type=template&id=2062eb60&scoped=true"
import script from "./AgentSideMenu.vue?vue&type=script&lang=ts"
export * from "./AgentSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./AgentSideMenu.vue?vue&type=style&index=0&id=2062eb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062eb60",
  null
  
)

export default component.exports